import { useEffect, useState } from 'react';
import { jsonAxios } from 'components/axios';
import MyPageTemplate from 'components/template/MyPageTemplate';
import { INotiList } from 'types/noti';
import { useNavigate } from 'react-router-dom';
import Loading from 'components/common/Loading';
import CustomInput from 'components/common/CustomInput';
import { ReactComponent as Reset } from 'assets/common/reset.svg'
import { ReactComponent as Nodata } from "assets/header/notiNodata.svg";
import { ReactComponent as Direct } from "assets/notification/direct.svg";
import CustomSelect from 'components/common/CustomSelect';
import { notificationSelect } from 'data/mypage';

const Notification = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [notiList, setNotiList] = useState<INotiList[]>([]);
    const [searchInfo, setSearchInfo] = useState({
        search: '',
        categoryType: ''
    })

    const tHeader = [
        { label: "생성일", flex: 0.5 },
        { label: "구분", flex: 0.5 },
        { label: "계정", flex: 1.0 },
        { label: "내용", flex: 2.0 },
        { label: "설정", flex: 0.5 },
    ];

    useEffect(() => {
        getNotiList();
    }, [searchInfo])

    const getNotiList = () => {
        setLoading(true)

        const params = new URLSearchParams(Object.entries(searchInfo)).toString();
        jsonAxios.get(`notification?${params}`).then(res => {
            if (res.data.code === 200) {
                const notificationList = res.data.data
                setNotiList(notificationList)
                const idList = notificationList
                    .filter((item: INotiList) => item.isConfirm === false)
                    .map((item: INotiList) => item.id);

                if (idList.length > 0) {
                    postNotiCheck(idList);
                }
            }
        }).finally(() => {
            setTimeout(() => {
                setLoading(false)
            }, 400)
        })
    }

    const postNotiCheck = (idList: number[]) => {
        const reqData = {
            idList: idList
        }
        jsonAxios.post('notification/check', reqData)
    }

    const titleStyle = () => {
        return `hidden tablet:flex justify-center items-center flex-[0.5] w-full bg-[#e5e5e5] py-1 h-full`
    }

    const tBodyStyle = () => {
        return `flex items-center justify-center py-2 text-center tablet:py-0 tablet:gap-2`
    }
    return (
        <MyPageTemplate background='bg-[#F8F8FA]'>
            <div className='flex flex-col gap-25 h-full min-h-dvh'>
                <div className="flex flex-col gap-6 py-10 tablet:py-4">
                    <div className='flex flex-col gap-3 bg-white hover:shadow-lg rounded-xl w-full transition-all'>
                        <div className='flex justify-between items-center mobile:p-6 px-10 tablet:px-4 py-6 border-b'>
                            <p className='font-semibold tablet:text-lg text-2xl'>견적/운임 알림 검색</p>
                        </div>
                        <div className='flex items-center tablet:items-end gap-4 mobile:p-6 px-10 tablet:px-4 py-6'>
                            <div className='flex tablet:flex-col flex-1 tablet:flex-[4] justify-center items-center gap-6'>
                                <div className='tablet:w-full'>
                                    <CustomSelect
                                        className='w-[180px] tablet:w-full'
                                        height={60}
                                        fontSize={18}
                                        isWhite={false}
                                        border={false}
                                        value={
                                            searchInfo.categoryType !== ''
                                                ? notificationSelect.find(arr => arr.value === searchInfo.categoryType)
                                                : null
                                        }
                                        option={notificationSelect}
                                        placeholder={'구분'}
                                        onChange={(value) => {
                                            setSearchInfo(p => ({
                                                ...p,
                                                categoryType: value
                                            }))
                                        }}
                                    />
                                </div>
                                <CustomInput
                                    className='w-full'
                                    type='text'
                                    placeholder='알림 내용을 검색해주세요'
                                    value={searchInfo.search}
                                    onChange={(e) => {
                                        setSearchInfo(p => ({
                                            ...p,
                                            search: e.target.value
                                        }))
                                    }}
                                />
                            </div>
                            <div className='flex-1'>
                                {
                                    (searchInfo.search.length > 0 || searchInfo.categoryType.length > 0) &&
                                    <div
                                        className='group flex justify-center items-center border rounded-md w-15 tablet:w-10 h-15 tablet:h-10 overflow-hidden cursor-pointer'
                                        onClick={() => {
                                            setSearchInfo({
                                                search: '',
                                                categoryType: ''
                                            })
                                        }}
                                    >
                                        <Reset className='group-hover:scale-120 transition-all' />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className='flex flex-col gap-3 bg-white hover:shadow-lg p-10 mobile:p-6 tablet:px-4 rounded-xl w-full transition-all'>
                        {
                            loading ?
                                <div className='flex justify-center items-center w-full'>
                                    <Loading />
                                </div> :
                                <>
                                    <div className='tablet:hidden flex bg-[#F8F8FA] font-semibold text-sm 2xl:text-base'>
                                        {
                                            notiList.length > 0 &&
                                            tHeader.map((item, idx) => (
                                                <div
                                                    key={idx}
                                                    className={`flex-[${item.flex}] flex items-center justify-center h-15`}
                                                >
                                                    {item.label}
                                                </div>
                                            ))
                                        }
                                    </div>

                                    {
                                        notiList.length > 0 ?
                                            <div className='flex flex-col gap-3 min-h-[30vh]'>
                                                {
                                                    notiList.map((item, idx) => (
                                                        <div
                                                            className={`relative flex text-sm border border-[#E1E1E8] transition-all rounded tablet:flex-col tablet:gap-1 xl:h-20  hover:bg-[#EEF4FF]`}
                                                            key={idx}
                                                        >
                                                            {
                                                                !item.isConfirm &&
                                                                <div className='top-2 left-2 absolute bg-red rounded-full w-2 h-2'></div>
                                                            }
                                                            <div className={`flex-[0.5] ${tBodyStyle()} tablet:order-1`}>
                                                                <p className={titleStyle()}>{tHeader[0].label}</p>
                                                                <p className='flex-1'>
                                                                    {item.createAt}
                                                                </p>
                                                            </div>
                                                            <div className={`flex-[0.5] ${tBodyStyle()} tablet:order-2`}>
                                                                <p className={titleStyle()}>{tHeader[1].label}</p>
                                                                <p className='flex-1'>
                                                                    {item.categoryName}
                                                                </p>
                                                            </div>
                                                            <div className={`flex-[1.0] ${tBodyStyle()} tablet:order-3`}>
                                                                <p className={titleStyle()}>{tHeader[2].label}</p>
                                                                <p className='flex-1'>
                                                                    {item.username}
                                                                </p>
                                                            </div>
                                                            <div className={`flex-[2.0] ${tBodyStyle()} tablet:order-4`}>
                                                                <p className={titleStyle()}>{tHeader[3].label}</p>
                                                                <p className='flex-1 text-left'>
                                                                    {item.content}
                                                                </p>
                                                            </div>
                                                            <div
                                                                className={`flex-[0.5] ${tBodyStyle()} tablet:order-5`}
                                                                onClick={() => {
                                                                    if (item.categoryType === 'order') {
                                                                        navigate(`/transport/detail?id=${item.orderId}`, {
                                                                            state: {
                                                                                stepName: item.orderStepName,
                                                                            },
                                                                        });
                                                                    }
                                                                    else if (item.categoryType === 'notice') {
                                                                        navigate(`/mypage/notice/detail?id=${item.noticeId}`)
                                                                    }
                                                                    else if (item.categoryType === 'quote') {
                                                                        navigate(`/quote/status/detail?id=${item.quoteId}`)
                                                                    }
                                                                }}
                                                            >
                                                                <p className={titleStyle()}>{tHeader[4].label}</p>
                                                                <p className='flex flex-1 justify-center items-center gap-1 text-primary cursor-pointer'>
                                                                    <Direct />
                                                                    바로가기
                                                                </p>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            :
                                            <div className='flex flex-col justify-center items-center gap-2 py-6 min-h-[30vh]'>
                                                <Nodata />
                                                <p className='text-[#D0D2D5]'>알림이 없습니다.</p>
                                            </div>
                                    }
                                </>
                        }
                    </div>
                </div>
            </div>
        </MyPageTemplate>
    )
}

export default Notification